<script lang="ts">
	import { ethers } from 'ethers';

	export let symbol: string;
	export let icon: string;
	export let balance: string | undefined = undefined;
	export let unit: string = 'eth';
	export let addButton = false;
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher<{ addButton: boolean }>();

	function addButtonClicked() {
		dispatch('addButton', true);
	}

	function getFormattedBalance(_unit: string, _balance: string | undefined) {
		if (typeof _balance === 'undefined') {
			return '#.##';
		}
		if (_unit === 'eth') {
			return Math.round(parseFloat(ethers.utils.formatEther(`${_balance}`)) * 1e8) / 1e8;
		} else {
			return Number(_balance).toLocaleString();
		}
	}

	$: formattedBalance = getFormattedBalance(unit, balance);
</script>

<div class="balance-card">
	<div class="card-info-container">
		<div class="card-info-icon flex icon-{icon}" />
		<div class="symbol-label">{symbol}</div>
	</div>
	<div class="flex justify-between grow w-full items-center">
		<div class="balanace-label">{formattedBalance}</div>
		{#if addButton}
			<div
				role="button"
				tabindex="0"
				on:keypress
				on:click={addButtonClicked}
				class="flex text-white"
			>
				<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
				<svg
					fill="currentcolor"
					height="24px"
					width="24px"
					version="1.2"
					baseProfile="tiny"
					id="Layer_1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					viewBox="0 0 256 256"
					xml:space="preserve"
				>
					<path
						id="XMLID_1_"
						d="M245,176v80H10v-80h57v22H43v30h167v-30h-19v-22H245z M29,111V0h58v23.7C97,27.5,105.1,35,108.6,45H182v26
		 v147H75v-59.4c-1,0.2-1.5,0.2-2,0.2c-1.1,0-1.8-0.2-2.3-0.2c-0.9-0.3-2.1-0.7-2.8-1.2c-1-0.7-1.9-1.8-2.6-2.7
		 c-0.5-0.9-0.9-2-1.1-2.8c-0.2-0.7-0.1-1.6-0.1-2.5v-46.3c0-1.9-1.9-3.8-4-3.8c-1.9,0-4,1.6-4,3.8v36.7c-1,0-1.6,0-2.1-0.2
		 c-3.1-0.7-6-2.8-7-5.8c-0.5-1-0.9-2.3-0.9-3.5V99.3c0-1.9-1.4-3.8-3.5-3.8c-1.9,0-3.5,1.6-3.5,3.8v21.3C34,120.6,29,116.4,29,111z
		  M108,132h5c1,6,4.7,8.4,8.9,8.4c4.2,0,7-2.6,8.9-7.8c1.6-3.8,2.4-5.6,4.4-5.6c1.6,0,3,1.6,3,4.5c0,3-0.9,5-1.4,6.3l5.4,1.5
		 c0.9-1.7,1.6-4.3,1.6-7.3h4.3v-4h-4.5c-1-5-4.4-7.8-8.7-7.8c-4.4,0-7.2,3.5-8.9,8.6c-1.4,3.7-2.4,5.1-4.4,5.1s-3.3-1.8-3.3-4.9
		 c0-3,0.9-6,1.9-7.7l-5.6-1.5c-0.7,1.6-1.7,5.3-1.7,8.3H108V132z M83,194.1c7.9,2.3,14.2,8.6,16.6,16.6l58.8-0.1
		 c2.4-7.9,8.7-14.2,16.6-16.5V70c-8-2.4-14.4-8.8-16.7-16.9l-0.2,0c0,0,0-0.1,0-0.1h-0.2c0,0,0,0.1,0,0.1l-47.7,0.1
		 c0,1,0.1,45.2,0.1,59.3c4.6-4.6,10.9-7.4,17.9-7.4c14,0,25.3,11.4,25.3,25.3s-11.4,25.3-25.3,25.3s-25.3-11.4-25.3-25.3
		 c0-1.5,0.1-3,0.4-4.5c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.2,0-0.2,0c-0.6,0-1.3,0.2-1.8,0.2c-5.4,0-9.8-4.4-9.8-9.7
		 c0-0.7,0.1-34.7,0.1-34.7c0-1.9-1.8-3.8-3.9-3.8c-1.8,0-2.9,1.4-3.9,3.3V194.1z"
					/>
				</svg>
			</div>
		{/if}
	</div>
</div>

<style>
	.balanace-label {
		display: flex;
		align-items: baseline;
		gap: 8px;
		align-self: stretch;

		color: var(--white, #fff);

		/* body-B-02 */
		font-size: 32px;
		font-family: Lato;
		font-style: normal;
		font-weight: 700;
		line-height: 120%;
	}
	.symbol-label {
		color: var(--gray-50, #a7a7a7);

		/* body-R-05 */
		font-size: 16px;
		font-family: Lato;
		font-style: normal;
		font-weight: 400;
		line-height: 140%;
	}
	.card-info-container {
		display: flex;
		height: 24px;
		align-items: center;
		gap: 4px;
		align-self: stretch;
	}
	.balance-card {
		display: flex;
		width: 280px;
		padding: 32px 24px;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		gap: 8px;

		border-radius: 12px;
		border: 2px solid var(--popup-border, #2d2d2d);
		background: linear-gradient(135deg, rgba(57, 57, 57, 0.7) 0%, rgba(40, 40, 40, 0.7) 100%);

		/* black_shadow */
		box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.2);
	}
</style>
